import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import HSGHeader from './Component/HSGHeader';
import Phi from '../../Phi/Phi'

const mapStateToProps = (state, ownProps) => {
    
  let userProfile = state.auth.userProfile
  // userProfile = userProfile && JSON.parse(userProfile) || {}

  return {
    userProfile,

    childList: state.child.childList || [],
    childCurrent: state.child.selectedChild || 0,
    sidebar:state.auth.showSideBar
  }
}

const mapDispatchToProps = (dispatch) => {
    return {
      logoutUser: () => dispatch(Actions.logoutUser()), 
      updateSelectedChild: (index) => dispatch(Actions.selectChild(index)),
      unsetSidebarHandler: (sideBarState) => dispatch(Actions.unsetSidebar(sideBarState)),
      setSidebarHandler: (sideBarState) => dispatch(Actions.setSidebar(sideBarState))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HSGHeader)

